import {
  HEADER_FIRST_LINE,
  HEADER_SECOND_LINE,
  BODY_FIRST_LINE,
  BODY_SECOND_LINE,
  BODY_SECOND_LINE_STATUS,
  SELECT_FOOTER,
  BTN_ACTION,
  BTN_EXPORT,
  BTN_UPLOAD,
  BTN_FILTER,
  COL_FILTER
} from '@/shared/constants/report';

import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';

export default {
  name: "ReportMixin",

  mixins: [
    GenericFunctionsMixin,
  ],

  computed: {
    headerFirstLine() {
      return HEADER_FIRST_LINE;
    },

    headerSecondLine() {
      return HEADER_SECOND_LINE;
    },

    colFilter() {
      return COL_FILTER;
    },

    btnFilter() {
      return BTN_FILTER;
    },

    bodyFirstLine() {
      return BODY_FIRST_LINE;
    },

    bodySecondLine() {
      return BODY_SECOND_LINE;
    },

    bodySecondLineStatus() {
      return BODY_SECOND_LINE_STATUS;
    },

    selectFooter() {
      return SELECT_FOOTER;
    },

    btnAction() {
      return BTN_ACTION;
    },

    btnUpload() {
      return BTN_UPLOAD;
    },

    btnExport() {
      return BTN_EXPORT;
    },
  }
}